'use client';

import { productPageHierarchy } from '../_components/productPageHierarchy';
import { FeaturePageNav } from '../_components/featurePageNav';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <FeaturePageNav pageHierarchy={productPageHierarchy.troubleshoot} />

      {children}
    </>
  );
}
